import { ValueWithRandom } from "../../ValueWithRandom.js";
export class ParticlesBounceFactor extends ValueWithRandom {
    constructor() {
        super();
        this.value = 1;
    }
}
